import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//

import { mapActions } from 'vuex';
import { HIDE_TOAST } from '@/constants/actions';
export default {
  name: 'widget__toast',
  methods: Object.assign({}, mapActions([HIDE_TOAST])),
  data: function data() {
    return {
      lifespan: 1500
    };
  },
  mounted: function mounted() {
    setTimeout(this[HIDE_TOAST], this.lifespan);
  }
};